module.exports = __webpack_public_path__ + "img/pointcard-btn.f893765a.png";